"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupTooltipVariant = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PopupTooltipVariant;
(function (PopupTooltipVariant) {
    PopupTooltipVariant[PopupTooltipVariant["LIGHT"] = 0] = "LIGHT";
    PopupTooltipVariant[PopupTooltipVariant["DARK"] = 1] = "DARK";
})(PopupTooltipVariant = exports.PopupTooltipVariant || (exports.PopupTooltipVariant = {}));
var propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    testId: PropTypes.string,
    ariaDescribeBy: PropTypes.string,
    mods: PropTypes.string,
    textHighlightColor: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    variant: PropTypes.oneOf([PopupTooltipVariant.LIGHT, PopupTooltipVariant.DARK]),
};
var PopupTooltip = function (_a) {
    var text = _a.text, testId = _a.testId, ariaDescribeBy = _a.ariaDescribeBy, mods = _a.mods, textHighlightColor = _a.textHighlightColor, children = _a.children, _b = _a.variant, variant = _b === void 0 ? PopupTooltipVariant.DARK : _b;
    var buttonRef = React.useRef(null);
    var tooltipRef = React.useRef(null);
    var _c = React.useState(false), isPopupOpen = _c[0], setIsPopupOpen = _c[1];
    var _d = React.useState({
        centerX: 0,
        centerY: 0,
    }), center = _d[0], setCenter = _d[1];
    var describedby = ariaDescribeBy ? ariaDescribeBy.toLocaleLowerCase().replace(/ /g, '-') : null;
    var centerContent = React.useCallback(function () {
        if (buttonRef && buttonRef.current) {
            var _a = buttonRef.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
            var closestScrollableParent = buttonRef.current.closest('.Modal-body'); // Assuming the modal (or any scrollable container) has a class of `.scrollable`
            console.log('closestScrollableParent', closestScrollableParent);
            var parentOffset = { x: 0, y: 0 };
            if (closestScrollableParent) {
                var parentRect = closestScrollableParent.getBoundingClientRect();
                parentOffset = { x: parentRect.left, y: parentRect.top };
            }
            var centerX = left + width / 2 - parentOffset.x;
            var centerY = top_1 - height - parentOffset.y;
            setCenter({
                centerX: centerX,
                centerY: centerY,
            });
        }
    }, []);
    React.useEffect(function () {
        if (isPopupOpen) {
            window.addEventListener('scroll', centerContent, true);
        }
        else {
            window.removeEventListener('scroll', centerContent, true);
        }
    }, [isPopupOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Popup Popup--tooltip ".concat(mods), "data-testid": testId, onMouseEnter: function () {
                centerContent();
                setIsPopupOpen(true);
            }, onMouseLeave: function () { return setIsPopupOpen(false); } },
            React.createElement("span", { "aria-describedby": describedby, ref: buttonRef, className: textHighlightColor }, children),
            React.createElement("div", { role: "tooltip", id: describedby, "aria-hidden": !!isPopupOpen, ref: tooltipRef, className: "Popup-container ".concat(isPopupOpen ? 'is-open' : '', " ").concat(variant === PopupTooltipVariant.LIGHT
                    ? 'Popup-container--light'
                    : 'Popup-container--dark'), style: { top: "".concat(center.centerY, "px"), left: "".concat(center.centerX, "px") } },
                React.createElement("div", { className: "Popup-content u-padEndsSm u-padSidesMd u-colorNeutral3 ".concat(variant === PopupTooltipVariant.LIGHT ? 'Popup-content--light' : 'Popup-tooltip--dark') }, text)))));
};
exports.default = PopupTooltip;
